import PageRouteContextInterface, { PageRouteAction } from "@app/Interface/PageRouteContextInterface";
import TypeAssertions from "@app/utils/TypeAssertions";

export const pageRouteReducer = (pageRouteState: PageRouteContextInterface, pageRouteAction: PageRouteAction): PageRouteContextInterface => {

    let updatedState: PageRouteContextInterface;

    switch (pageRouteAction.type) {

        case "GET":
            return pageRouteState;
            break;

        case "UPDATE":
        case "SYNC_PAGE_ROUTES":

            // copy the original sate, use the payload for data
            updatedState = { ...pageRouteState, pageRoutes: pageRouteAction.payload };

            return updatedState;

        default:
            // returns error if unhandled case  
            return TypeAssertions.assertNeverPageRouteAction(pageRouteAction);

    }

}